import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import { usePointsChangesState } from '../../../stores/PointsChangesTableProvider'
import apiClient from '../../../utils/api/apiClient'
import { APIEndpoints } from '../../../utils/api/apiConfig'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { getErrorMessageFromApiResponse } from "../../../utils/api/apiUtils"
import ModalComponent2 from '../../Modals/ModalComponent2'
import PointsChangesTable from '../../PointsChanges/PointsChangesTable'
import { useObserver } from 'mobx-react'
import useStores from '../../../stores/useStore'

const StyledHeaderButtons = styled.div`

@media screen and (min-width:768px) {
    display:flex;
    justify-content: flex-end;
}
@media (max-width: 767px) {
    button{
        width:100%;
        margin-bottom:1rem;
    }
}
`


const PointsChangesApproval = () => {
  const { selectedCheckBoxes, setSelectedCheckBoxes, fetchPointsChanges } = usePointsChangesState()
  const [reject, setReject] = useState(false)
  const [release, setRelease] = useState(false)
  const [remove, setRemove] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { t } = useTranslation()
  const [error, setError] = useState('')
  const { uiStore } = useStores()
  const allowReleasePointsChanges = useObserver(() => uiStore.allowReleasePointsChanges)

  const submit = async (type, message) => {
    setError('')
    const endpoint = prepareEndpoint(type)
    const params = prepareParams(message)
    try {
      setIsLoading(true)
      await apiClient.postJson(endpoint, params)
      setSelectedCheckBoxes([])
      fetchPointsChanges()
      cancelActions()
    } catch (e) {
      setError(getErrorMessageFromApiResponse(e))
    } finally {
      setIsLoading(false)
    }
  }

  //array of ids to array of objects [id1,id2] => [{comment:"",id:id1},{comment:"", id:id2}]
  const prepareParams = (message) => {
    const result = selectedCheckBoxes.map(id => {
      var rObj = {}
      rObj.comment = message
      rObj.id = id
      return rObj
    })
    return result
  }

  const prepareEndpoint = (type) => {
    let endpoint = ''
    switch (type) {
      case 'release':
        endpoint = APIEndpoints.pointsChangeRequest.releases
        break;
      case 'reject':
        endpoint = APIEndpoints.pointsChangeRequest.rejections
        break;
      case 'remove':
        endpoint = APIEndpoints.pointsChangeRequest.cancellations
        break;
      default:
      // code block
    }
    return endpoint
  }

  const cancelActions = () => {
    setReject(false)
    setRelease(false)
    setRemove(false)
    setIsLoading(false)
    setError('')
  }

  return (
    <>
      <StyledHeaderButtons>

        {allowReleasePointsChanges ? <div>
          <Button
            className="mb-3 me-2"
            disabled={selectedCheckBoxes.length === 0}
            variant="success"
            onClick={() => setRelease(true)}
          >{t('release')}</Button>
          <Button
            className="mb-3"
            disabled={selectedCheckBoxes.length === 0}
            variant="danger"
            onClick={() => setReject(true)}
          >{t('reject')}</Button>
        </div>
          : <Button
            className="mb-3"
            disabled={selectedCheckBoxes.length === 0}
            variant="danger"
            onClick={() => setRemove(true)}
          >{t('delete')}</Button>}
      </StyledHeaderButtons>

      <PointsChangesTable />
      {reject && (<ModalComponent2
        ModalTitle={t('pointsChanges:rejectTitle')}
        BodyPart1={t('pointsChanges:rejectBody')}
        button1Function={(comment) => { submit('reject', comment) }}
        button1Text={t('reject')}
        button1Variant="danger"
        button1Loading={isLoading}
        bodyStyle="alert alert-danger"
        functionCancel={cancelActions}
        inputType="textarea"
        inputLabel={t('comment')}
        error={error}
      />)}

      {release && (<ModalComponent2
        ModalTitle={t('pointsChanges:releaseTitle')}
        BodyPart1={t('pointsChanges:releaseBody')}
        button1Function={(comment) => { submit('release', comment) }}
        button1Text={t('release')}
        button1Variant="success"
        button1Loading={isLoading}
        bodyStyle="alert alert-success"
        functionCancel={cancelActions}
        inputType="textarea"
        inputLabel={t('comment')}
        error={error}
      />)}

      {remove && (<ModalComponent2
        ModalTitle={t('pointsChanges:deleteTitle')}
        BodyPart1={t('pointsChanges:deleteBody')}
        button1Function={(comment) => { submit('remove', comment) }}
        button1Text={t('delete')}
        button1Variant="danger"
        button1Loading={isLoading}
        bodyStyle="alert alert-danger"
        functionCancel={cancelActions}
        inputType="textarea"
        inputLabel={t('comment')}
        error={error}
      />)}

    </>
  )
}

export default PointsChangesApproval
